import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ShowLayout from "layouts/ShowLayout";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  label: {
    color: 'gray',
  }
})


class EquipmentsShow extends React.PureComponent {

  render() {
    const { classes, equipment } = this.props;

    if (!equipment) return <div>Loading...</div>

    return (
      <div className={classes.root}>

        <ShowLayout moduleName={'equipments'}>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12}>
              <Typography variant="subtitle2" gutterBottom className={classes.label}>
                Equipment:
              </Typography>
              <Typography variant="h6" gutterBottom>
                {equipment.name}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" gutterBottom className={classes.label}>
                Notes:
              </Typography>
              <Typography variant="body1" gutterBottom>
                {equipment.notes}
              </Typography>
            </Grid>
          </Grid>
        </ShowLayout>
      </div>
    )
  }
}


EquipmentsShow.defaultProps = {
  isEditing: false,
}

export default withStyles(styles)(EquipmentsShow)
